import * as React from 'react';
import './progressBar.scss';
import { cn } from '../../utils';

interface Props {
  progress?: `${number}%` | number;
  className?: string;
}

export const ProgressBar = ({ className, progress }: Props) => {
  const width = getPercentage(progress);
  const style = width ? { width } : null;
  return (
    <div className={cn('progress-bar', { [className]: !!className })}>
      <div />
      <div className="bar-line" style={style} />
      <div>
        <span />
      </div>
    </div>
  );
};

const upTo2Decimal = (n: number) => Math.round(n * 100) / 100;
const getPercentage = (p: string | number) => {
  if (!p) return null;
  let n = p as number;
  if (typeof p == 'string') {
    n = parseFloat(p.replace('%', ''));
  }
  return upTo2Decimal(n) + '%';
};
